import React from 'react';

/** Visual app chrome only — no signed-in user, role, or tenant data. */
export function TenantSelectBackdrop() {
  const nav = [
    { label: 'OVERVIEW', kind: 'section' },
    { label: 'Dashboard', active: true },
    { label: 'WORKSPACE', kind: 'section' },
    { label: 'Administration' },
    { label: 'Analytics' },
  ];
  const cards = [
    { title: 'Job roles created', color: '#FB923C' },
    { title: 'Candidates Stack Ranked', color: '#60A5FA' },
    { title: 'Resume scoring above 50%', color: '#34D399' },
    { title: 'Resumes Formatted', color: '#2DD4BF' },
  ];
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 3900,
        display: 'flex',
        pointerEvents: 'none',
        fontFamily: "'Plus Jakarta Sans','Inter',sans-serif",
        background: '#F2F4F8',
      }}
    >
      <aside
        style={{
          width: 230,
          flexShrink: 0,
          height: '100%',
          background: '#0D1117',
          borderRight: '1px solid rgba(255,255,255,0.08)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ height: 2, background: 'linear-gradient(90deg,#1A5FD4,#3B82F6)' }} />
        <div
          style={{
            height: 52,
            padding: '0 14px',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            borderBottom: '1px solid rgba(255,255,255,0.07)',
          }}
        >
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: 9,
              background: 'linear-gradient(135deg,#1A5FD4,#2563EB)',
              color: '#fff',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            H
          </div>
          <div>
            <div style={{ fontSize: 9, color: '#6B7280', letterSpacing: '0.14em' }}>FEUJI</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>ReachOut</div>
          </div>
        </div>
        <div style={{ padding: '16px 14px', flex: 1 }}>
          {nav.map((item) => (
            item.kind === 'section' ? (
              <div
                key={item.label}
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  color: '#6B7280',
                  letterSpacing: '0.08em',
                  margin: '14px 8px 8px',
                }}
              >
                {item.label}
              </div>
            ) : (
              <div
                key={item.label}
                style={{
                  padding: '8px 10px',
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 600,
                  color: item.active ? '#fff' : '#9CA3AF',
                  background: item.active ? 'rgba(26,95,212,0.35)' : 'transparent',
                }}
              >
                {item.label}
              </div>
            )
          ))}
        </div>
      </aside>
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            height: 52,
            background: 'rgba(255,255,255,0.9)',
            borderBottom: '1px solid #E2E8F0',
            display: 'flex',
            alignItems: 'center',
            padding: '0 28px',
            fontSize: 12,
            color: '#94A3B8',
          }}
        >
          ReachOut <span style={{ margin: '0 8px' }}>›</span>
          <span style={{ color: '#0F172A', fontWeight: 600 }}>Analytics Overview</span>
        </div>
        <div style={{ padding: '28px 32px' }}>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#0F172A' }}>Analytics</div>
          <div style={{ marginTop: 6, fontSize: 13, color: '#64748B' }}>
            Choose a tenant to continue.
          </div>
          <div
            style={{
              marginTop: 22,
              background: '#fff',
              borderRadius: 16,
              border: '1px solid #E2E8F0',
              padding: 20,
              display: 'grid',
              gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
              gap: 14,
            }}
          >
            {cards.map((card) => (
              <div
                key={card.title}
                style={{
                  borderRadius: 12,
                  border: '1px solid #E2E8F0',
                  borderLeft: `4px solid ${card.color}`,
                  padding: '16px 18px',
                  background: '#fff',
                }}
              >
                <div style={{ fontSize: 13, color: '#64748B', fontWeight: 600 }}>{card.title}</div>
                <div style={{ fontSize: 28, fontWeight: 800, color: '#CBD5E1', marginTop: 8 }}>—</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function TenantSelectModal({
  tenants = [],
  selectedId,
  onChange,
  onContinue,
  submitting = false,
  error = '',
}) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="tenant-select-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 4000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(15, 23, 42, 0.38)',
        backdropFilter: 'blur(1px)',
        padding: 24,
        fontFamily: "'Plus Jakarta Sans','Inter',sans-serif",
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 440,
          background: '#fff',
          borderRadius: 16,
          border: '1px solid #E2E8F0',
          boxShadow: '0 24px 60px rgba(15, 23, 42, 0.18)',
          padding: '28px 32px 24px',
        }}
      >
        <h2
          id="tenant-select-title"
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 700,
            color: '#0F172A',
            lineHeight: 1.4,
          }}
        >
          You have access to multiple tenants. Would you like to switch?
        </h2>
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
          {tenants.map((tenant) => {
            const id = tenant.id;
            const checked = String(selectedId) === String(id);
            return (
              <label
                key={id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '10px 12px',
                  borderRadius: 10,
                  border: `1px solid ${checked ? '#1A5FD4' : '#E2E8F0'}`,
                  background: checked ? '#F4F8FF' : '#fff',
                  cursor: submitting ? 'default' : 'pointer',
                  color: '#0F172A',
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                <input
                  type="radio"
                  name="reachout-tenant"
                  value={id}
                  checked={checked}
                  disabled={submitting}
                  onChange={() => onChange(id)}
                  style={{ accentColor: '#1A5FD4', width: 16, height: 16 }}
                />
                {tenant.name || tenant.slug || `Tenant ${id}`}
              </label>
            );
          })}
        </div>
        {error ? (
          <div style={{ marginTop: 12, color: '#DC2626', fontSize: 13 }}>{error}</div>
        ) : null}
        <button
          type="button"
          onClick={onContinue}
          disabled={submitting || selectedId == null}
          style={{
            marginTop: 22,
            width: '100%',
            border: 'none',
            borderRadius: 10,
            padding: '12px 16px',
            background: submitting || selectedId == null ? '#93C5FD' : '#1A5FD4',
            color: '#fff',
            fontSize: 14,
            fontWeight: 700,
            cursor: submitting || selectedId == null ? 'not-allowed' : 'pointer',
          }}
        >
          {submitting ? 'Continuing…' : 'Continue'}
        </button>
      </div>
    </div>
  );
}
